import { useState } from 'react';

const ContactSection = () => {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [selectedNature, setSelectedNature] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const form = e.currentTarget;
    const formData = new FormData(form);

    // Sujet dynamique avec le type de demande
    const nature = formData.get('Nature_de_la_demande') as string;
    const subject = nature
      ? `Polar Clim – Nouvelle demande : ${nature}`
      : 'Polar Clim – Nouvelle demande de contact';

    formData.append('_subject', subject);
    formData.append('_captcha', 'false');
    formData.append('_template', 'table');
    formData.append('_lang', 'fr');

    try {
      const response = await fetch('https://formsubmit.co/Horn@gmx.fr', {
        method: 'POST',
        body: formData,
      });
      if (response.ok) {
        setSubmitted(true);
        form.reset();
        setSelectedNature('');
      }
    } catch {
      // silent
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="w-full bg-white py-24">
      <div className="max-w-5xl mx-auto px-6">

        {/* Header */}
        <div className="text-center mb-12">
          <span className="text-[#1a8abf] text-xs font-bold uppercase tracking-widest">Contactez-nous</span>
          <h2 className="text-3xl lg:text-4xl font-black text-[#002060] leading-tight mt-3 mb-4">
            Demander un devis ou planifier une intervention
          </h2>
          <p className="text-[#4a6272] text-base max-w-xl mx-auto">
            Notre équipe technique s'engage à vous recontacter au plus vite.
          </p>
        </div>

        {/* Info cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
          {[
            { icon: 'ri-phone-line', label: 'Téléphone', value: '06 51 34 11 60', href: 'tel:0651341160' },
            { icon: 'ri-mail-line', label: 'MAIL', value: 'Horn@gmx.fr', href: 'mailto:Horn@gmx.fr' },
            { icon: 'ri-time-line', label: 'Disponibilités', value: 'Lun – Sam : 8h–20h', href: null },
            { icon: 'ri-map-pin-line', label: "Zone d'intervention", value: 'Nice et environs', href: null },
          ].map(({ icon, label, value, href }) => (
            <div
              key={label}
              className="flex flex-col items-center text-center gap-3 p-5 rounded-2xl border border-[#cce8f4] bg-[#f0f8fc]"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl" style={{ background: 'linear-gradient(135deg, #002060 0%, #1a8abf 100%)' }}>
                <i className={`${icon} text-white text-lg`} />
              </div>
              <div>
                <p className="text-[#4a6272] text-xs font-medium uppercase tracking-wide">{label}</p>
                {href ? (
                  <a href={href} className="text-[#002060] font-bold text-sm hover:text-[#1a8abf] transition-colors">{value}</a>
                ) : (
                  <p className="text-[#002060] font-bold text-sm">{value}</p>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Form */}
        <div className="rounded-3xl border border-[#cce8f4] bg-[#f0f8fc] p-8 lg:p-12">
          {submitted ? (
            <div className="flex flex-col items-center justify-center text-center gap-4 py-12">
              <div
                className="w-16 h-16 flex items-center justify-center rounded-full"
                style={{ background: 'linear-gradient(135deg, #004f9a 0%, #6ec5d8 100%)' }}
              >
                <i className="ri-check-double-line text-white text-3xl" />
              </div>
              <h3 className="text-2xl font-bold text-[#002a5e]">Demande envoyée !</h3>
              <p className="text-[#4a6272]">Notre équipe vous contactera au plus vite.</p>
              <button
                onClick={() => setSubmitted(false)}
                className="mt-4 text-[#004f9a] font-semibold underline underline-offset-4 cursor-pointer"
              >
                Envoyer une nouvelle demande
              </button>
            </div>
          ) : (
            <>
              <h3 className="text-2xl font-bold text-[#002a5e] mb-8">Votre demande</h3>
              <form
                data-readdy-form
                id="devis-polar-clim"
                onSubmit={handleSubmit}
                className="grid grid-cols-1 md:grid-cols-2 gap-5"
              >
                <div>
                  <label className="block text-sm font-semibold text-[#1a3a60] mb-2">Nom et Prénom *</label>
                  <input
                    type="text"
                    name="Nom_et_Prenom"
                    required
                    placeholder="Jean Dupont"
                    className="w-full px-4 py-3 rounded-lg border border-[#cce8f4] bg-white text-[#1a3a60] text-sm focus:outline-none focus:border-[#004f9a] transition-colors"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-[#1a3a60] mb-2">Adresse e-mail *</label>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="jean.dupont@exemple.fr"
                    className="w-full px-4 py-3 rounded-lg border border-[#cce8f4] bg-white text-[#1a3a60] text-sm focus:outline-none focus:border-[#004f9a] transition-colors"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-[#1a3a60] mb-2">Numéro de téléphone</label>
                  <input
                    type="tel"
                    name="Telephone"
                    placeholder="06 00 00 00 00"
                    className="w-full px-4 py-3 rounded-lg border border-[#cce8f4] bg-white text-[#1a3a60] text-sm focus:outline-none focus:border-[#004f9a] transition-colors"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-[#1a3a60] mb-2">Code postal / Ville *</label>
                  <input
                    type="text"
                    name="Code_postal_et_Ville"
                    required
                    placeholder="06000 Nice"
                    className="w-full px-4 py-3 rounded-lg border border-[#cce8f4] bg-white text-[#1a3a60] text-sm focus:outline-none focus:border-[#004f9a] transition-colors"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-[#1a3a60] mb-2">Nature de la demande *</label>
                  <select
                    name="Nature_de_la_demande"
                    required
                    value={selectedNature}
                    onChange={(e) => setSelectedNature(e.target.value)}
                    className="w-full px-4 py-3 rounded-lg border border-[#cce8f4] bg-white text-[#1a3a60] text-sm focus:outline-none focus:border-[#004f9a] transition-colors cursor-pointer"
                  >
                    <option value="">Sélectionnez une option</option>
                    <option value="Installation">Installation</option>
                    <option value="Entretien">Entretien</option>
                    <option value="Dépannage">Dépannage</option>
                    <option value="PAC - Pompe à Chaleur">PAC - Pompe à Chaleur</option>
                    <option value="VMC / CTA">VMC / CTA</option>
                    <option value="Bilan énergétique">Bilan énergétique</option>
                    <option value="Autres">Autres</option>
                  </select>
                </div>

                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold text-[#1a3a60] mb-2">Message</label>
                  <textarea
                    name="Message"
                    rows={4}
                    maxLength={500}
                    placeholder="Décrivez votre besoin..."
                    className="w-full px-4 py-3 rounded-lg border border-[#cce8f4] bg-white text-[#1a3a60] text-sm focus:outline-none focus:border-[#004f9a] transition-colors resize-none"
                  />
                  <p className="text-[#4a6272] text-xs mt-1">Maximum 500 caractères</p>
                </div>

                <div className="md:col-span-2">
                  <button
                    type="submit"
                    disabled={submitting}
                    className="w-full text-white py-4 rounded-lg font-bold text-base hover:opacity-90 transition-opacity cursor-pointer disabled:opacity-60 whitespace-nowrap"
                    style={{ background: 'linear-gradient(90deg, #003580 0%, #4ab8d0 100%)' }}
                  >
                    {submitting ? 'Envoi en cours...' : 'Envoyer ma demande'}
                  </button>
                </div>
              </form>
            </>
          )}
        </div>

        {/* Map */}
        <div className="mt-10 rounded-3xl border border-[#cce8f4] overflow-hidden">
          <div className="px-6 py-5 bg-[#f0f8fc] border-b border-[#cce8f4] flex items-center gap-3">
            <div className="w-9 h-9 flex items-center justify-center rounded-xl" style={{ background: 'linear-gradient(135deg, #002060 0%, #1a8abf 100%)' }}>
              <i className="ri-map-pin-line text-white text-base" />
            </div>
            <div>
              <h4 className="text-[#002060] font-bold text-sm">Zone d&apos;intervention</h4>
              <p className="text-[#4a6272] text-xs">Nice, Côte d&apos;Azur et environs – Alpes-Maritimes (06)</p>
            </div>
          </div>
          <iframe
            title="Zone d'intervention Polar Clim – Nice et environs"
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d89068.24!2d7.2620!3d43.7102!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sfr!2sfr!4v1700000000000!5m2!1sfr!2sfr"
            width="100%"
            height="380"
            style={{ border: 0, display: 'block' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
          <div className="px-6 py-4 bg-[#f0f8fc] border-t border-[#cce8f4] flex flex-wrap gap-3">
            {['Nice', 'Antibes', 'Cannes', 'Menton', 'Grasse', 'Cagnes-sur-Mer', 'Saint-Laurent-du-Var', 'Vence', 'Villeneuve-Loubet'].map((ville) => (
              <span key={ville} className="text-xs font-medium text-[#1a8abf] bg-white border border-[#cce8f4] rounded-full px-3 py-1">
                {ville}
              </span>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default ContactSection;
